import React, { memo } from 'react';

import BaseModal from '../BaseModal';

import './index.css';

const DealerInfoModal = (props) => {
  const { dealer } = props;
  const body = (
    <div className="info-modal">
      <h2 className="info-modal__title">{dealer.name}</h2>
      <p className="info-modal__row">
        <span className="info-modal__label">Company</span>
        <span className="info-modal__value">{dealer.name}</span>
      </p>
      <p className="info-modal__row">
        <span className="info-modal__label">Auto Make</span>
        <span className="info-modal__value">{dealer.brand}</span>
      </p>
      <p className="info-modal__row">
        <span className="info-modal__label">Street Address</span>
        <span className="info-modal__value">{dealer.address}</span>
      </p>
      <p className="info-modal__row">
        <span className="info-modal__label">Zip</span>
        <span className="info-modal__value">{dealer.zip}</span>
      </p>
      <p className="info-modal__row">
        <span className="info-modal__label">Email</span>
        <span className="info-modal__value">{dealer.email}</span>
      </p>
      <p className="info-modal__row">
        <span className="info-modal__label">Phone</span>
        <span className="info-modal__value">{dealer.phone}</span>
      </p>
      <p className="info-modal__row">
        <span className="info-modal__label">Contact</span>
        <span className="info-modal__value">{dealer.contact}</span>
      </p>
    </div>
  )

  return (
    <BaseModal
      onClose={props.toggleModal}
      body={body}
    />
  );
}

export default memo(DealerInfoModal);
